import React from 'react';
import { twMerge } from 'tailwind-merge';
import { getRow } from '@components/Song/Audience/helpers';
import {
  DEFAULT_MOBILE_SEAT_COUNT,
  DEFAULT_TABLET_SEAT_COUNT,
  SECOND_THIRD_ROW_DESKTOP,
  SECOND_THIRD_ROW_MOBILE,
} from '@components/Song/Audience/shared/constants';
import { SeatingGrid } from '@components/Song/Audience/shared/styles';
import { useMediaQuery } from '@context/mediaQuery';

const seats = ({ length, midRowCount }: { length: number; midRowCount: number }) => {
  return Array.from({ length: length }, (_, index) => {
    const row = getRow({
      index,
      midRowMax: midRowCount,
    });

    return (
      <div
        className={twMerge(
          row,
          'relative col-span-3 aspect-square h-auto w-full ',
          'animate-pulse rounded-md bg-neutral100 md:col-span-2',
        )}
        key={`empty-seat-${index}`}
      />
    );
  });
};

export const SeatingSkeleton = () => {
  const { tablet } = useMediaQuery();

  const emptySeatCount = tablet ? DEFAULT_TABLET_SEAT_COUNT : DEFAULT_MOBILE_SEAT_COUNT;
  const midRowCount = tablet ? SECOND_THIRD_ROW_DESKTOP : SECOND_THIRD_ROW_MOBILE;

  return <SeatingGrid>{seats({ length: emptySeatCount, midRowCount: midRowCount })}</SeatingGrid>;
};
